import { useState } from "react";
import Chart from "react-apexcharts";
import "./DashboardSocialBarDaily.css";

const DashboardSocialBarDaily = () => {
  const [date, setDate] = useState("Last 30 days");
  const [showDate, setShowDate] = useState(false);
  const chooseDropdown = (e) => {
    setDate(e.target.value);
    setShowDate((showDate) => !showDate);
  };
  const [options] = useState({
    chart: {
      type: "bar",
      //   stacked: true,
      toolbar: {
        show: false,
      },
      events: {
        dataPointMouseEnter: function (event) {
          event.path[0].style.cursor = "pointer";
        },
      },
      fontFamily: "poppins",
    },
    grid: {
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
      show: false, // you can either change hear to disable all grids
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        show: true,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return "$" + value.toFixed(2);
        },
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 7,
        columnWidth: "60%",
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      colors: [
        "#CFDBE7",
        "#4318ff",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
        "#CFDBE7",
      ],
    },
    legend: {
      show: false,
      horizontalAlign: "left",
      position: "top",
      customLegendItems: ["Instagram", "Twitter"],
      fontFamily: "poppins",
      markers: {
        radius: 20,
        fillColors: ["#f14c64", "#1d9bf0"],
      },
      labels: {
        colors: "#757679",
      },
    },
  });
  const [series] = useState([
    {
      name: "Total Budget",
      data: [44, 55, 41, 37, 22, 43, 21, 33, 52, 13, 43, 32],
    },
  ]);
  return (
    <div className="dashboardSocialBar">
      <div className="dashboardSocialBar__header flex-row">
        <div className="dashboardSocialBar__headerLeft">
          <span>Total Budget</span>
          <h3>$682.5</h3>
        </div>
        <div className="dashboardSocialBar__dropdown">
          <div
            className={`dropdown-container flex-row ${showDate && "expand"}`}
            onClick={() => setShowDate((showDate) => !showDate)}
          >
            <p>{date}</p>
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 4L8 12L16 20"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`dropdown-item-container flex-column ${
              showDate && "expand"
            }`}
          >
            <label htmlFor="DateOne">
              <input
                type="radio"
                name="Date"
                id="DateOne"
                value="one"
                onChange={chooseDropdown}
              />
              one
            </label>
            <label htmlFor="DateTwo">
              <input
                type="radio"
                name="Date"
                id="DateTwo"
                value="two"
                onChange={chooseDropdown}
              />
              two
            </label>
            <label htmlFor="DateThree">
              <input
                type="radio"
                name="Date"
                id="DateThree"
                value="three"
                onChange={chooseDropdown}
              />
              three
            </label>
            <label htmlFor="DateFour">
              <input
                type="radio"
                name="Date"
                id="DateFour"
                value="four"
                onChange={chooseDropdown}
              />
              four
            </label>
            <label htmlFor="DateFive">
              <input
                type="radio"
                name="Date"
                id="DateFive"
                value="five"
                onChange={chooseDropdown}
              />
              five
            </label>
          </div>
        </div>
      </div>

      <Chart
        options={options}
        series={series}
        height="250"
        // height="100%"
        // width="100%"
        // width="590"
        type="bar"
      />
    </div>
  );
};

export default DashboardSocialBarDaily;
